import React from "react";

// Styles
import AccrualsContainer from "./Accruals.styles";

// Font Awesome
import Tabs from "components/Common/Tabs/Tabs";
import InputTab from "components/Screens/DailyRecs/Accruals/InputTab/InputTab";
import PowerBIDashboard from "../../../../components/Common/PowerBIDashboard";

interface AccrualsProps {}

const Accruals = ({}: AccrualsProps) => {
    return (
        <AccrualsContainer>
            <p data-cy="navs-main-title" className={"sectionTitle"}>
                ACCRUALS
            </p>
            <Tabs
                defaultTab="current_inputs"
                tabs={[
                    {
                        value: "current_inputs",
                        title: "CURRENT INPUTS",
                        permissions: ["p_can_view_navs", "p_can_action_navs"],
                        content: <InputTab noSignOff />,
                    },
                    {
                        value: "proposed_inputs",
                        title: "PROPOSED INPUTS",
                        permissions: ["p_can_view_navs", "p_can_action_navs"],
                        content: <InputTab />,
                    },
                    {
                        value: "report",
                        title: "REPORT",
                        permissions: ["p_can_view_navs", "p_can_action_navs"],
                        content: (
                            <div className="iframeContainer">
                                <PowerBIDashboard
                                    reportId="cc106493-9114-4074-a725-2c0046f7d783"
                                    workspaceId="a42e71f1-8daa-48e5-a1d6-ad5674016128"
                                ></PowerBIDashboard>
                            </div>
                        ),
                    },
                ]}
            />
        </AccrualsContainer>
    );
};
export default Accruals;
